import { render, staticRenderFns } from "./RecommendedBy.vue?vue&type=template&id=85e0da2a"
import script from "./RecommendedBy.vue?vue&type=script&lang=js"
export * from "./RecommendedBy.vue?vue&type=script&lang=js"
import style0 from "./RecommendedBy.vue?vue&type=style&index=0&id=85e0da2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VDataTable,VIcon,VSpacer,VSwitch})
